import { css } from 'emotion';

export namespace styles {
  export const container = css({});
}
